export default __webpack_public_path__ + "static/screenFourthSectionEnBig-695bd696cb2b625062e00fc0a903256f.webp";